import { Pipe, PipeTransform } from '@angular/core';
import { MapItem } from '@capturum/ui/api';

@Pipe({
  name: 'sortAlphabetically',
})
export class SortAlphabeticallyPipe implements PipeTransform {
  transform(items: MapItem[], sortAlphabetically: boolean, sortBy = 'label'): MapItem[] {
    if (!Array.isArray(items)) {
      return [];
    }

    if (!sortAlphabetically) {
      return items;
    }

    return this.#sort(items, sortAlphabetically, sortBy);
  }

  #sort(value: MapItem[], sortAlphabetically: boolean, sortBy: string): MapItem[] {
    return value?.sort((a, b) => {
      // If sortAlphabetically is selected, do a LowerCase() and otherwise leave it for numeric
      const valueA = typeof a[sortBy] === 'string' && sortAlphabetically ? a[sortBy].toLowerCase() : a[sortBy];
      const valueB = typeof b[sortBy] === 'string' && sortAlphabetically ? b[sortBy].toLowerCase() : b[sortBy];

      return valueA > valueB ? 1 : -1;
    });
  }
}
